<script>
  import { createEventDispatcher } from 'svelte'

  import { focus } from '../misc.js'

  import authStore from '../auth/store.js'

  import toastStore from './toast/store.js'

  import PageSub from './page-sub.svelte'


  let queueName

  const dispatch = createEventDispatcher()

  const back = function () {
    dispatch('back')
  }

  const addQueue = function () {
    const url = '/api/user/queues'
    const data = {
      'name': queueName.trim(),
    }
    return authStore.request({method: 'post', url, data})
      .then(() => toastStore.success('Added'))
      .catch(e => toastStore.error('Failed to add queue', e))
      .then(() => dispatch('added'))
  }
</script>


<PageSub title="Add Queue" on:back={back}>
  <form id="addQueue" on:submit|preventDefault={addQueue}>
    <div class="labeledInputWrapper">
      <label for="queueName">Queue Name</label>
      <input id="queueName"
             placeholder="Enter a queue name"
             bind:value={queueName} use:focus
             maxlength="50" required pattern=".*\S.*">
    </div>
  </form>
  <div slot="controls" class="controls">
    <div class="toolbar">
      <span class="spacer"></span>
      <button class="greyButton" type="submit" form="addQueue">Add</button>
    </div>
  </div>
</PageSub>

<style>
  form {
    flex-grow: 1;

    display: flex;
    flex-direction: column;

    padding: 10px;

    border-top: 1px solid var(--border-color);
    border-bottom: 1px solid var(--border-color);
  }
</style>